import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    q: '90影视是否需要注册才能观看？',
    a: '不需要。90影视支持免注册免费在线观看，打开网站即可直接浏览和播放所有影视内容。注册账号后可以获得播放记录同步、收藏片单等额外功能。',
  },
  {
    id: 2,
    q: '如何找到90影视的最新访问地址？',
    a: '建议收藏本站当前网址，或下载90影视APP获取最稳定的访问方式。本站也会通过官方渠道及时更新最新地址，确保用户始终能够正常访问。',
  },
  {
    id: 3,
    q: '90影视支持哪些设备观看？',
    a: '90影视全面支持网页端（PC/Mac）、手机浏览器、平板以及iOS和Android APP，所有平台均可享受高清流畅的观影体验，播放记录支持云端同步。',
  },
  {
    id: 4,
    q: '影片加载缓慢或无法播放怎么办？',
    a: '建议尝试切换播放线路（点击播放器右下角线路切换按钮），或检查网络连接状态。如问题持续存在，可清除浏览器缓存后重试，或通过联系我们反馈具体影片链接。',
  },
  {
    id: 5,
    q: 'APP下载需要收费吗？有什么特别功能？',
    a: '90影视APP完全免费下载使用。APP端支持离线缓存下载、倍速播放、弹幕互动、夜间模式等专属功能，观影体验比网页端更加流畅便捷。可在本页APP下载区域获取安装包。',
  },
];

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<number[]>([1]);

  const toggle = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            关于90影视的常见使用问题与解答
          </p>
        </div>

        <div className="max-w-[720px] mx-auto space-y-3">
          {faqItems.map((item) => {
            const isOpen = openIds.includes(item.id);
            return (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-2">
                    {item.q}
                  </h3>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}